import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import AppHeader from "@/components/feature/AppHeader";
import AppFooter from "@/components/feature/AppFooter";
import HeroSection from "@/pages/home/components/HeroSection";
import OverviewCards from "@/pages/home/components/OverviewCards";
import StatusPanel from "@/pages/home/components/StatusPanel";
import ActivityFeed from "@/pages/home/components/ActivityFeed";
import HelpCenter from "@/pages/home/components/HelpCenter";
import { useHomeData } from "@/pages/home/hooks/useHomeData";

export default function Home() {
  const { stats, metrics, activities, loading, error, reload } = useHomeData();
  const location = useLocation();

  useEffect(() => {
    if (!location.hash) return;
    const target = document.querySelector(location.hash);
    if (target) {
      target.scrollIntoView({ behavior: "smooth" });
    }
  }, [location.hash]);

  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <AppHeader />
      <main className="flex-1">
        <HeroSection stats={stats} loading={loading} />
        <OverviewCards stats={stats} loading={loading} />
        <StatusPanel metrics={metrics} stats={stats} loading={loading} />
        <ActivityFeed activities={activities} stats={stats} loading={loading} error={error} onRetry={reload} />
        <HelpCenter />
      </main>
      <AppFooter />
    </div>
  );
}